import { BasicSelect, MultiSelect } from 'vue-search-select';
import CryptoJS from 'crypto-js';
import Pagination from './../../../shared/components/pagination';
import CustomExpandableTable from '../../../shared/components/customExpandableTable';
import Loader from '../../../shared/components/loader';
import Treeselect from '@riophae/vue-treeselect';
import Utility from './../../../utility/services/utility.service';
import FTCMemoDepositSlip from './../../../firstAndLastmilemanagement/views/FtcRadShipment/FTCMemoDepositSlip';
import TripServices from './../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
import Printd from 'printd'

const moment = require('moment');

export default {
  name: 'updateFTCcharges',
  components: {
    Treeselect,
    CryptoJS,
    Pagination,
    BasicSelect,
    CustomExpandableTable,
    Loader,
    Printd,
    FTCMemoDepositSlip,
    'first': "viewcashmemo",
  },
    'second': "editftccharges",
    
  data: function () {
    return {
      currentTab: 'First',
      componentKey:1,
      tabs: [
        { key:'First', value:'View Tax Invoice'},
        { key:'Second', value:'Edit FTC Charges'},
      ],
      expanded: false,
      isLoading: false,
      accordianTab: { 1: false, 2: false, 3: false ,4:false ,5:false},
      volweight:"",
      phyweight:"",
      apliweight:"",
      chargeweight:"",
      billweight:"",
      freightrate:"",
      freightcharge:"",
      min:"",
      max:"",
      rate:"",
      type:"",
      charges:"",
      payblecharges:"",
      vehiclecharges:"",
      rtocharges:"",
      odacharges:"",
      loadingcharges:"",
      dccharges:"",
      loadingcharges:"",
      ftccharges:"",
      deliverycharges:"",
      holidaycharges:"",
      fuelcharges:"",
      handlingcharges:"",
      deliveryattempcharges:"",
      grounfloorcharges:"",
      demurragecharges:"",
      greentax:"",
      shipmentsizecharges:"",
      mathadicharges:"",
      portgagescharges:"",
      specialdeliverycharges:"",
      fulltruckload:"",
      unloadingcharges:"",
      odaawbcharges:"",
      gst:"",
      awbnumber:"",
      applicablecharge:"",
      invoicevalue:"",
      type:"",
      chargetype:"",
      waybillcharges:"",
      ftctotalamtwogst:"",
      totalFTCamount:"",
      FOVchargetype:"",
      totalfreightcharges:"",
      totalinsurancecharges:"",
      totalaccessorialCharges:"",
      totalawbextracharges:"",
      showFTCAmount:false,
      printAwb:[],
      confirmDisabled:false,
      showPrintCashMemo:false,
      showFTCdetails:false,
      defaultHubId:"",
      awbErr:""
    }
  },
  computed: {
    onChange(){
      this.totalfreightcharges = Number(this.freightcharge);
      this.totalinsurancecharges = Number(this.payblecharges);
      this.totalaccessorialCharges = 
      Number(this.odacharges) +
      Number(this.rtocharges) +
      Number(this.greentax) +
      Number(this.dccharges) +
      Number(this.demurragecharges) +
      Number(this.ftccharges) +
      Number(this.deliverycharges) +
      Number(this.fuelcharges) +
      Number(this.holidaycharges) +
      Number(this.vehiclecharges) +
      Number(this.waybillcharges) +
      Number(this.deliveryattempcharges) +
      Number(this.handlingcharges) +
      Number(this.grounfloorcharges) + 
      Number(this.loadingcharges) ;

      this.totalawbextracharges = 
      Number(this.odaawbcharges) +
      Number(this.mathadicharges) +
      Number(this.portgagescharges) +
      Number(this.fulltruckload) +
      Number(this.shipmentsizecharges) +
      Number(this.specialdeliverycharges) +
      Number(this.unloadingcharges);

      this.ftctotalamtwogst = 
      Number(this.totalfreightcharges) +
      Number(this.totalinsurancecharges) +
      Number(this.totalaccessorialCharges) +
      Number(this.totalawbextracharges) 

      this.totalFTCamount = Math.round(Number(this.ftctotalamtwogst) +(Number(this.ftctotalamtwogst/100) * Number(this.gst)))

    },
  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.useremail = userdetail.email;
    this.defaultHubId = userdetail.hubID
  },
  methods: {
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      }  // restrict to 2 decimal places 
      else if(evt.target._value!=null && evt.target._value.indexOf(".")>-1 && (evt.target._value.split('.')[1].length > 1)){
      evt.preventDefault();
      }
      else {
        return true;
      }
    },
    async onTabClick(key){
      this.currentTab = key;
      this.isLoading = true;
      await this.setMulipleAwbData()
      this.isLoading = false;
    },
    expandAll() {
      this.expanded = true;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = true;
      }
    },
    collapseAll() {
      this.expanded = false;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = false;
      }
    },
    toggleCheck(tabid) {
      this.expanded = false;
      for (var key in this.accordianTab) {
        if (tabid != key) {
          this.accordianTab[key] = false;
        }
      }
    },
    isIntegerOnly: function(evt) {
      this.checkErr();
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();;
      } else {
        return true;
      }
      
    },
    async printCashMemo(){
      try {
        if (this.printAwb.length < 1) {
          this.isLoading = false
          return
        }
      const d = new Printd();
      var buffer = '';

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
               font-size:20%;
           }
           hr {
                margin-top: 1rem;
                margin-bottom: 1rem;
                border: 1;
                border-top: 1px solid #000;
            }
           table {
               border-collapse: collapse;
               margin-left:3px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:5px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
          @media print {
          .pagebreak {
          page-break-after: always;
          }
          }
          `
          this.$nextTick(() => {
            d.print(document.getElementById('printCashMemoData'), cssText);
          })
    } catch (error) {
      this.isLoading=false
      }
    },
    checkErr(){
      let err = false
      if(this.awbnumber == "" || this.awbnumber == null) {
       err = true
       this.awbErr = 'Please enter AWB No.'
     }else{
      this.awbErr = ''
     }
      return err
    },
    async getFTCDetails(){
      try{
        if(this.checkErr()){
          return false
        }
          this.isLoading=true;
          this.showFTCdetails = false;
            let freightCharges;
            let accessorialCharges;
            let awbextracharges;
            let insurancecharge;
          
            let inputPayload = {
              awb: this.awbnumber
            };
            let result = await Utility.getFTCdetailsdata(inputPayload);
            this.expanded = true;
            if(result.data.code == 200 && !result.data.data.isPaid){
              this.tabs= [
                { key:'First', value:'View Tax Invoice'},
                { key:'Second', value:'Edit FTC Charges'},
              ];
              this.onTabClick('First')
            this.showFTCdetails = true;
            freightCharges = result.data.data.freightCharges
            this.volweight = freightCharges.volumetricweight
            this.apliweight = freightCharges.applicableweight
            this.billweight = freightCharges.billWeight
            this.chargeweight = freightCharges.minimumChargeableweight
            this.phyweight = freightCharges.physicalweight
            this.freightcharge = freightCharges.freightCharges
            this.freightrate = freightCharges.freightRateperKG

            insurancecharge = result.data.data.insurancecharge
            this.type = insurancecharge.fovtype
            this.invoicevalue = insurancecharge.invoicevalue
            this.applicablecharge = insurancecharge.applicableCharge
            this.FOVchargetype = insurancecharge.FOVchargetype
            this.payblecharges = insurancecharge.fovPayable
            this.FOVchargetype = insurancecharge.FOVchargetype
            this.charges = insurancecharge.fovCharges
            this.rate = insurancecharge.fovrate
            this.min = insurancecharge.min
            this.max = insurancecharge.max
           
            awbextracharges = result.data.data.awbextracharges
            this.odaawbcharges = awbextracharges.oda
            this.mathadicharges = awbextracharges.mathadi
            this.portgagescharges = awbextracharges.portgages
            this.fulltruckload = awbextracharges.fulltruckload
            this.shipmentsizecharges = awbextracharges.shipmentsized
            this.specialdeliverycharges = awbextracharges.specialdelivery
            this.unloadingcharges = awbextracharges.loadingunloading

            accessorialCharges = result.data.data.accessorialCharges
            this.odacharges = accessorialCharges.oda
            this.rtocharges = accessorialCharges.rto
            this.greentax = accessorialCharges.greentax
            this.dccharges = accessorialCharges.dcCharges
            this.demurragecharges = accessorialCharges.demurrage
            this.ftccharges = accessorialCharges.fodcharges
            this.deliverycharges = accessorialCharges.openpickup
            this.fuelcharges = accessorialCharges.fuelsurcharge
            this.holidaycharges = accessorialCharges.holidaycharges
            this.vehiclecharges = accessorialCharges.vehiclecharges
            this.waybillcharges = accessorialCharges.waybillcharges
            this.deliveryattempcharges = accessorialCharges.deliveryattempt
            this.handlingcharges = accessorialCharges.handlingcharges
            this.grounfloorcharges = accessorialCharges.groundfloorcharges 
            this.loadingcharges = 0
            this.gst = result.data.data.gst
            this.ftctotalamtwogst = result.data.data.ftctotalamtwogst            
            this.totalFTCamount = result.data.data.totalFTCamount
            this.totalfreightcharges = result.data.data.totalfreightcharges
            this.totalinsurancecharges = result.data.data.totalinsurancecharges
            this.totalaccessorialCharges = result.data.data.totalaccessorialCharges
            this.totalawbextracharges = result.data.data.totalawbextracharges
            this.expandAll();
            this.isLoading=false;
            }else if(result.data.code == 200 && result.data.data.isPaid){
              this.tabs= [
                { key:'First', value:'View Tax Invoice'},
              ],
            this.showFTCdetails = true;
              this.isLoading=false;
              this.onTabClick('First')
            }
            else{
              this.$alert(result.data.message, "", "error");
              this.isLoading=false;

            }
          }
      catch(err){
        this.$alert(err,"","error");
      }
    },
    async clickPrintCashMemo() {
      this.isLoading = true;
      await this.setMulipleAwbData()
      this.showPrintCashMemo = true;
      this.isLoading = false;
    },
    async GetCashMemoData(){
      let payload = {
        awb:this.awbnumber,
      }
      let data = await TripServices.GetCashMemoData(payload)
      return data
    },
    async setMulipleAwbData(){
      this.printAwb=[]
        let data = await this.GetCashMemoData()
        if(data.data.code == 200){
        this.printAwb.push(data.data.data)
        }else{
          this.$alert(item.AWB + " - " + data.data.message,"", "error");
        }
    },
    clickConfirmAction() {
      this.showFTCAmount = true;
    },
    closeconfirmtab() {
      this.showFTCAmount = false;
    },
    async onSubmitSearch() {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.getFTCDetails();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    async generateCashMemo(){
      try {
        this.showFTCAmount = false;
        this.isLoading = true;
        let payload = {
          awb:this.awbnumber,
          ftcamount : this.totalFTCamount,
          lastmodifiedby: this.useremail
        }
        let data = await TripServices.GenerateCashMemo(payload);
        if(data.data.code == 200){
          this.$alertify.success("FTC amount confirmed successfully. Payment link sent to consignee");
          this.isLoading = false;
          this.confirmDisabled = true;
        }else{
          this.$alertify.error(data.data.message);
        this.isLoading = false;
        }
      } catch (err) {
        this.isLoading = false;
      }
    },
    async updateFTCCharges(){
      try{
         this.isLoading = true;
         let apiPayload = {
          "freightCharges": {
            "billWeight": this.billweight,
            "freightRate": 0,
            "freightCharges": this.freightcharge,
            "physicalweight": this.phyweight,
            "freightratetype": 1,
            "applicableweight": this.apliweight,
            "freightRateperKG": this.freightrate,
            "volumetricweight": this.volweight,
            "minimumChargeableweight": this.chargeweight
          },
          "insurancecharge": {
            "max": this.max,
            "min": this.min,
            "fovrate": this.rate,
            "fovtype": this.type,
            "fovCharges": this.charges,
            "fovPayable": this.payblecharges,
            "invoicevalue": this.invoicevalue,
            "FOVchargetype": this.FOVchargetype,
            "applicableCharge": this.applicablecharge
          },
          "accessorialCharges": {
            "oda": this.odacharges,
            "rto": this.rtocharges,
            "greentax": this.greentax,
            "dcCharges": this.dccharges,
            "demurrage": this.demurragecharges,
            "fodcharges": this.ftccharges,
            "openpickup": this.deliverycharges,
            "fuelsurcharge": this.fuelcharges,
            "holidaycharges": this.holidaycharges,
            "vehiclecharges": this.vehiclecharges,
            "waybillcharges": this.waybillcharges,
            "deliveryattempt": this.deliveryattempcharges,
            "handlingcharges": this.handlingcharges,
            "groundfloorcharges": this.grounfloorcharges
          },
          "awbextracharges": {
            "oda": this.odaawbcharges,
            "mathadi": this.mathadicharges,
            "portgages": this.portgagescharges,
            "fulltruckload": this.fulltruckload,
            "shipmentsized": this.shipmentsizecharges,
            "specialdelivery": this.specialdeliverycharges,
            "loadingunloading": this.unloadingcharges
          },
          "totalfreightcharges": this.totalfreightcharges,
          "totalinsurancecharges": this.totalinsurancecharges,
          "totalaccessorialCharges": this.totalaccessorialCharges,
          "totalawbextracharges": this.totalawbextracharges,
          "totalFTCamount": this.totalFTCamount,
          "gst": this.gst,
          "ftctotalamtwogst": this.ftctotalamtwogst,
          "awb":this.awbnumber
        }
         let result = await Utility.updateFTCCashmemo({awbpayload:apiPayload});
         if(result.data.code == 200){
          this.reset();
           this.$alertify.success(result.data.message)
           this.isLoading=false;
         }
         else{
          this.$alertify.error(result.data.message)
         }
          this.isLoading=false;
   }
   catch (err) {
    console.log(err);
    this.isLoading = false;
  }
 },
 async onSubmit() {
  this.$validator.validateAll().then((result) => {
    if(result){
      this.updateFTCCharges();
    }
  }).catch(() => {
    console.log('errors exist', this.errors)
  });
},
    reset(){
      this.showFTCAmount = false;
      this.awbnumber = "",
            this.apliweight = ""
            this.billweight = ""
            this.chargeweight ="" 
            this.phyweight = ""
            this.freightcharge = ""
            this.freightrate = ""
            this.volweight =""
            this.type = ""
            this.invoicevalue = ""
            this.applicablecharge = ""
            this.FOVchargetype = ""
            this.payblecharges = ""
            this.FOVchargetype = ""
            this.charges = ""
            this.rate = ""
            this.min = ""
            this.max = ""
            this.odaawbcharges = "",
            this.mathadicharges = ""
            this.portgagescharges = ""
            this.fulltruckload = ""
            this.shipmentsizecharges = ""
            this.specialdeliverycharges = ""
            this.unloadingcharges = ""
            this.odacharges = ""
            this.rtocharges = ""
            this.greentax = ""
            this.dccharges = ""
            this.demurragecharges = "" 
            this.ftccharges = ""
            this.deliverycharges = "" 
            this.fuelcharges = ""
            this.holidaycharges = ""
            this.vehiclecharges = ""
            this.waybillcharges = ""
            this.deliveryattempcharges = ""
            this.handlingcharges = ""
            this.grounfloorcharges = ""
            this.gst = ""
            this.ftctotalamtwogst = ""          
            this.totalFTCamount = ""
            this.totalfreightcharges = ""
            this.totalinsurancecharges = ""
            this.totalaccessorialCharges = ""
            this.totalawbextracharges = ""
            this.showFTCdetails =false
            this.printAwb=[]
            this.$validator.reset();
            this.collapseAll()
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/utility/views/updateFTCcharges/updateFTCcharges.component.js